import Index from "../../pages/snail/snail_5thLeading/index";
import Pc from "../../pages/snail/snail_5thLeading/pc";

const base = "snail_5thLeading";

const routes = [
  {
    path: `/${base}/index`,
    name: `${base}-index`,
    component: Index
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/pc*`,
    name: `${base}-pc`,
    component: Pc
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/snail/snail_5thLeading.js